export default {
  subcategory: {},
};
